module.exports = __webpack_public_path__ + "media/images/mprnews-archive-bg-widescreen-7858f823de083a2f5db2ec05793582a1.jpg";